import { createAction } from 'typesafe-actions';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ssoAction = createAction('sso/SSO_REQUEST')();
